<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section>
      <div class="mat-body-1 m-b-12">Time zone</div>
      <div>{{ voicemailAdvancedInfo.timezone }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Say date and time</div>
      <div>{{ voicemailAdvancedInfo.sayDateTime ? "Yes" : "No" }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Say message duration</div>
      <div>{{ voicemailAdvancedInfo.sayDuration ? "Yes" : "No" }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Say Caller ID</div>
      <div>{{ voicemailAdvancedInfo.sayCallerId ? "Yes" : "No" }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.PRESSING_ZERO_REDIRECTS_TO" | translate }}</div>
      <div>
        {{
          transferAddress
            ? "(" +
              (transferAddress.addressType | singularAddressType) +
              ") " +
              transferAddress.name
            : "None"
        }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Pager notification address</div>
      <div>{{ voicemailAdvancedInfo.pagerNumber || "none" }}</div>
    </section>
  </div>
  <div class="second-column">
    <section>
      <div class="mat-subtitle-1">Voice mailbox applies to:</div>
      <div class="mat-body-1 m-b-12">SIP address</div>
      <div>{{ sipAddress }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Extension(s)</div>
      @for (ext of voicemailAdvancedInfo.extensionsList; track ext) {
      <div [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_VIEW_SHELVE_EXTENSIONS">
        <div>{{ ext }}</div>
      </div>
      } @if (voicemailAdvancedInfo.extensionsList.length === 0) {
      <div>
        {{ "ONSIP_I18N.NO_VALUES" | translate : { values: "extensions" } }}
      </div>
      }
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button
    mat-flat-button
    class="toggle-button"
    color="primary"
    (click)="togglePanel()"
    [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_VIEW_SHELVE_ADVANCED_SETTINGS_EDIT"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
